/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { FilterMetadata } from 'primeng/api';
import { Observable, map, share, ReplaySubject } from 'rxjs';
import { Entity } from 'src/app/models/entity.model';
import { IPagingResultModel } from 'src/app/models/paging-result.model';

import { UserRole } from '../../constants';
import { CurrentUser } from '../../models/current-user.model';
import { MyProfile } from '../../models/my-profile.model';
import { ApiService } from '../api.service';
import { ICRUDService } from '../interfaces/crud.interface';
import { ICurrentUserPermissionsModel, IUsernameModel } from './users.service.models';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends ApiService implements ICRUDService {
  private userInfo: Observable<CurrentUser> | null = null;
  private securityId: number = 0;

  protected getApiUrl(): string {
    return 'users';
  }

  public currentUser(): Observable<CurrentUser> {
    if (!this.userInfo) {
      this.userInfo = this.baseGet('current').pipe(
        map((res: CurrentUser) => {
          this.securityId = res.permissionIds.reduce((sum, num) => sum + num, 0);
          return res;
        }),
        share({ connector: () => new ReplaySubject(1), resetOnRefCountZero: true }),
      );
    }
    return this.userInfo;
  }

  public getProfile(): Observable<any> {
    return this.baseGet('profile');
  }

  public getCurrentUserPermissionsAsync(): Observable<ICurrentUserPermissionsModel> {
    return this.baseGet('permissions');
  }

  public getDashboardInfo(): Observable<any> {
    return this.baseGet('dashboard');
  }

  public getFullName(token: string): Observable<IUsernameModel> {
    return this.baseGet(`fullname?token=${token}`);
  }

  public updateProfile(data: MyProfile): Observable<void> {
    let opts = this.getOptions();
    let sendData = JSON.stringify(data);
    let url = `${this.defaultApi}/profile`;
    return this.http.put(url, sendData, opts) as any;
  }

  public clearCurrentUser() {
    this.userInfo = null;
  }

  public checkSecurity(securityId: UserRole): boolean {
    return (this.securityId & securityId) !== 0;
  }

  public sendInvitation(...userIds: number[]) {
    return this.basePost(userIds, 'send-invitation');
  }

  public getById(id: string | number): Observable<any> {
    return this.baseGetById(id);
  }
  public post(data: any): Observable<void> {
    return this.basePost(data);
  }
  public put(id: string | number, data: any): Observable<void> {
    return this.basePut(id, data);
  }
  public delete(id: string | number): Observable<void> {
    return this.baseDelete(id);
  }
  public getPerPage(params: {
    page: number;
    size: number;
    customFilters: any;
    filters?: { [s: string]: FilterMetadata };
    sortField?: string;
    sortOrder?: number;
  }): Observable<IPagingResultModel<Entity<any>>> {
    return this.baseGetPerPage(params);
  }
}
